import { Context, useContext } from 'react';

export const useContextValue = <T, K extends keyof T | undefined = undefined>(
  context: Context<T>,
  key?: K,
): K extends keyof T ? T[K] : T => {
  const contextValue = useContext(context);

  if (key !== undefined) {
    return contextValue[key] as K extends keyof T ? T[K] : T;
  }

  return contextValue as K extends keyof T ? T[K] : T;
};
